import { Component } from "@angular/core";
import { AccountInfo } from "../../../account-info-header/models";
import { Observable, Subject, takeUntil } from "rxjs";
import { Store } from "@ngrx/store";
import { selectInfo } from "../../../account-info-header/reducers";
import { selectViewInContext } from "../../../shared/reducers";
import { StandingAuthMasterStatusViewActions } from "../../actions";

@Component({
  standalone: false,
  selector: 'mm-sa-master-status-view',
  templateUrl: './sa-master-status-view.component.html',
  styleUrls: ['./sa-master-status-view.component.scss'],
})
export class SaMasterStatusViewComponent {
  accountInfo: AccountInfo;
  destroy$ = new Subject<void>();
  createRequestStep$: Observable<string>;

  constructor(private store: Store) { }

  ngOnInit(): void {
      this.store.select(selectInfo).pipe(takeUntil(this.destroy$)).subscribe(accountInfo => {
        this.accountInfo = accountInfo;
      });

      this.createRequestStep$ = this.store.select(selectViewInContext);
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.unsubscribe();
    }

    refresh(masterAccountId: string): void {
        this.store.dispatch(StandingAuthMasterStatusViewActions.refreshSaMaster({ masterAccountId }));
    }

}
